module.exports = __webpack_public_path__ + "img/add-image-01.cae4563d.svg";